module.exports = __webpack_public_path__ + "img/FotoMo15.0fd69d50.jpeg";